import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Satellite, Globe2 } from 'lucide-react';
const missions = [{
  id: 1,
  title: 'פרויקט אוריון',
  status: 'פעיל',
  desc: 'רשת לווייני תקשורת קוונטית במסלול לווייני נמוך (LEO) המאפשרת העברת נתונים מאובטחת בזמן אמת.',
  icon: Satellite,
  color: 'from-cyan-500 to-blue-600',
  glow: 'rgba(6,182,212,0.5)'
}, {
  id: 2,
  title: 'משימת ארטמיס-IL',
  status: 'בפיתוח',
  desc: 'רכב חלל אוטונומי המיועד לחקר משאבים על פני הירח, בשיתוף סוכנויות חלל בינלאומיות.',
  icon: Rocket,
  color: 'from-violet-500 to-fuchsia-600',
  glow: 'rgba(139,92,246,0.5)'
}, {
  id: 3,
  title: 'מערכת גאיה',
  status: 'מבצעי',
  desc: 'מערך ניטור אקלים גלובלי המספק נתונים ברזולוציה גבוהה לחיזוי תופעות טבע קיצוניות.',
  icon: Globe2,
  color: 'from-blue-400 to-emerald-500',
  glow: 'rgba(59,130,246,0.5)'
}];
export function Missions() {
  return <section id="missions" className="py-24 relative z-10" data-id="element-120">
      <div className="max-w-7xl mx-auto px-6" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-123">
            משימות{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-500" data-id="element-124">
              חלוציות
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-125">
            אנו מובילים את חזית המחקר והפיתוח בחלל עם משימות שמשנות את פני
            האנושות.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-126">
          {missions.map((mission, idx) => <motion.div key={mission.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="group relative rounded-3xl bg-[#0a0b14] border border-white/10 p-8 overflow-hidden hover:border-white/30 transition-all duration-500" data-id="element-127">
              {/* Glow effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
            background: `radial-gradient(circle at 50% 0%, ${mission.glow} 0%, transparent 70%)`
          }} data-id="element-128" />

              <div className="relative z-10" data-id="element-129">
                <div className="flex justify-between items-start mb-6" data-id="element-130">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${mission.color} flex items-center justify-center shadow-lg`} data-id="element-131">
                    <mission.icon className="w-7 h-7 text-white" data-id="element-132" />
                  </div>
                  <span className="px-3 py-1 rounded-full bg-white/10 text-xs font-medium text-gray-300 border border-white/10 backdrop-blur-md" data-id="element-133">
                    {mission.status}
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-gray-400 transition-all" data-id="element-134">
                  {mission.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-135">{mission.desc}</p>

                <div className="mt-8 flex items-center text-sm font-medium text-cyan-400 opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" data-id="element-136">
                  <span data-id="element-137">למידע נוסף</span>
                  <svg className="w-4 h-4 mr-2 rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-138">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-139" />
                  </svg>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}